module.exports = __webpack_public_path__ + "img/Number=32.e4246f53.png";